import { ReactNode } from 'react';

import { Stack, SxProps, Theme } from '@mui/material';

interface IProps {
  heart: ReactNode;
  folder?: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Группа угловых действий карточки-ленты (`CardPhotoStrip`): [папка][сердце].
 * Одна абсолютная группа вместо двух абсолютных кнопок — сердце внутри группы
 * становится статичным. Плывёт ОВЕРЛЕЕМ поверх шапки ленты.
 *
 * `CardListRow` (18976, Р77, уточнение заказчика) больше НЕ использует этот
 * компонент: угловая группа строчных видов (`list`/`compact`), включая дот
 * статуса, переехала на ФИКСИРОВАННЫЙ верхний правый угол каркаса
 * (`ListRowFrame#trailing`, `getCornerSx`) — тот же механизм, что уже несёт
 * `CastingListRow#buildTrailing`. Прежний собственный оверлей домена
 * (свой `position: absolute`, свой контейнерный порог) заказчик прямо
 * потребовал заменить одним каркасом на все четыре домена; см.
 * `CardListRow#buildTrailing`.
 *
 * `gap: 0` — тач-цели 44×44 стоят вплотную: видимые круги 40×40 внутри них уже
 * дают на глаз тот же просвет, что раньше давал зазор темы, а лишний `gap`
 * поверх этого просвета отодвигал бы обе кнопки от края строки без пользы.
 * @param props - пропсы
 * @param props.heart - кнопка избранного (сердце), уже с `position: static`
 * @param props.folder - слот кнопки «в папку»; `undefined`, если экран его не заполнил
 * @param props.sx - позиционирование группы
 */
export const UserCardCornerActions = ({ heart, folder, sx }: IProps) => (
  <Stack
    direction='row'
    alignItems='center'
    gap={0}
    sx={{ position: 'absolute', zIndex: 3, ...sx }}
  >
    {folder}
    {heart}
  </Stack>
);
